<template>
  <div>
    <!-- <v-btn @click="$refs.multiInpputModal.open()">open</v-btn> -->
    <v-text-field
      dense
      outlined
      readonly
      append-icon="edit"
      class="pa-2"
      background-color="grey lighten-4"
      placeholder="Missing Parts"
      v-model="valueFormatted"
      :error="error"
      @click:append="$refs.multiInpputModal.open(input)"
      @click="$refs.multiInpputModal.open(input)"
    ></v-text-field>
    <AMultiInputModal ref="multiInpputModal" @update:input="inputs"></AMultiInputModal>
  </div>
</template>

<script>
import AMultiInputModal from "./AMultiInputModal";

export default {
  components: {
    AMultiInputModal
  },
  props: ["input", "error"],
  data() {
    return {
      value: []
    };
  },
  computed: {
    valueFormatted: function() {
      let v = "";
      this.input.forEach(e => {
        v = v + (v.length > 0 ? " " : "");
        v = v + e[0] + "(" + e[1] + ")";
      });
      return v;
    }
  },
  methods: {
    inputs(data) {
      this.input = [...data];
      this.$emit("update:input", this.input);
    }
  }
};
</script>